import React, { Component } from 'react';
import { Layout, Alert } from 'antd';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import Header from './Header';
import _ from 'lodash';
import { getNotifyCorrectMessage } from '@/shared/utils';
// import menuData from '@/menu-data';
import styles from './index.less';
function getMenuAllItems(data) {
    let res = [];
    data.forEach((item) => {
        if (item.children && item.children.length) {
            res = res.concat(getMenuAllItems(item.children));
        }
        // delete item.children;
        res.push(item);
    });
    return res;
}
function getNotifyMessage(array, parentId) {
    if (!parentId)
        return '';
    let notifyMessage = '';
    const parentItem = _.find(array, ['id', parentId]);
    const parentMessage = getNotifyCorrectMessage(parentItem);
    if (parentMessage) {
        notifyMessage = parentMessage;
    }
    else {
        notifyMessage = getNotifyMessage(array, parentItem.parentId || '');
    }
    return notifyMessage;
}
const mapStateToProps = ({ global, setting, menu, router }) => {
    const menuItems = getMenuAllItems(menu.menuList);
    return {
        collapsed: global.collapsed,
        sso: global.sso,
        layout: setting.layout,
        contentWidth: setting.contentWidth,
        hideLayoutInIframe: setting.hideLayoutInIframe,
        currentRoute: router,
        menuData: menu.menuList,
        menuItems,
    };
};
class BasicLayout extends Component {
    constructor() {
        super(...arguments);
        this.onCollapse = (collapsed) => {
            dispatch.global.SET_COLLAPSED(collapsed);
        };
    }
    render() {
        const { layout, contentWidth, collapsed, currentRoute, menuData, sso, hideLayoutInIframe, children, menuItems, } = this.props;
        if (hideLayoutInIframe && window.top !== window.self) {
            return children;
        }
        // 通知的消息，若自身有就显示自身的，否则就显示父级的
        let notifyMessage = '';
        const currentMenuItem = _.find(menuItems, { path: currentRoute.path });
        if (currentMenuItem) {
            notifyMessage = getNotifyCorrectMessage(currentMenuItem);
            if (!notifyMessage && currentMenuItem.parentId) {
                notifyMessage = getNotifyMessage(menuItems, currentMenuItem.parentId);
            }
        }
        return (<Layout>
        <Layout style={{ minHeight: '100vh' }}>
          <Header menuData={menuData} currentRoute={currentRoute} collapsed={collapsed} onCollapse={this.onCollapse} contentWidth={contentWidth} layout={layout} sso={sso}/>
          <Layout.Content className={styles.content}>
            {!!notifyMessage && (<Alert message={notifyMessage} type="info" closable style={{ margin: 10 }}/>)}
            {children}
          </Layout.Content>
        </Layout>
      </Layout>);
    }
}
export default connect(mapStateToProps)(BasicLayout);
